import { Suspense } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from '@mui/material';

import { PaddingBox } from '~components/atoms';
import { FieldInfo } from '~components/molecules';
import {
  usePinningStepContext,
  useVenuePlacementCreationContext,
} from '~providers';
import { formatContactName } from '~utils/normalize.util';

// Wrap the component with Suspense and provide the fallback
export const ConfirmVenueStep: React.FC = () => (
  <Suspense
    fallback={
      <Box
        display="flex"
        width="100vw"
        height="100vh"
        alignItems="center"
        justifyContent="center"
      >
        <CircularProgress />
      </Box>
    }
  >
    <ConfirmVenueStepView />
  </Suspense>
);

const ConfirmVenueStepView: React.FC = () => {
  const { existingVenueDetail } = useVenuePlacementCreationContext();
  const { goToNextStep, setIsPlacementAssignedStation, setIsRelocationFlow } =
    usePinningStepContext();

  if (!existingVenueDetail) return null;

  return (
    <>
      <PaddingBox
        flex={1}
        sx={{
          bgcolor: 'background.paper',
          width: '100%',
          height: '100%',
        }}
      >
        <Box display="flex" flexDirection="column" gap={4} width="100%">
          {/* Venue Pinning Info */}
          <Stack gap={1}>
            <Typography variant="h6" color="text.dark">
              Venue details
            </Typography>
            <FieldInfo
              label="Venue Name"
              value={existingVenueDetail.locationName}
            />
            <FieldInfo
              label="Venue Type"
              value={existingVenueDetail.venueTypeName || ''}
            />
            <FieldInfo
              label="Venue Sub-Type"
              value={existingVenueDetail.venueSubTypeName || 'None'}
            />
            <FieldInfo
              label="Address"
              value={existingVenueDetail.addressLine1 || ''}
            />
          </Stack>

          {/* Venue Contact Info */}
          <Stack gap={1}>
            <Typography variant="h6" color="text.dark">
              Venue's contact
            </Typography>
            <FieldInfo
              label="Name"
              value={formatContactName(existingVenueDetail.venueContact)}
            />
            <FieldInfo
              label="Email"
              value={existingVenueDetail.venueContact?.email || '---'}
            />
            <FieldInfo
              label="Phone Number"
              value={existingVenueDetail.venueContact?.phone || '---'}
            />
            <FieldInfo
              label="Title / Role"
              value={existingVenueDetail.venueContact?.role || '---'}
            />
          </Stack>
        </Box>
      </PaddingBox>
      <PaddingBox
        alignItems="center"
        bgcolor="background.paper"
        position="fixed"
        bottom={0}
        width="100%"
      >
        <Button
          fullWidth
          size="large"
          variant="contained"
          style={{ borderRadius: '100px' }}
          onClick={() => {
            setIsPlacementAssignedStation(false);
            setIsRelocationFlow(false);
            goToNextStep();
          }}
        >
          <Typography variant="body2" fontWeight={500}>
            Continue
          </Typography>
        </Button>
      </PaddingBox>
    </>
  );
};
